<template>
  <section
    id="section4"
    ref="root"
    class="ta-section"
    :class="{ 'is-armed': armed, 'is-revealed': revealed }"
    aria-labelledby="sec4"
  >
    <div class="ta-section__grid" aria-hidden="true"></div>

    <div class="container ta-section__inner">
      <header class="ta-head">
        <p class="ta-head__eyebrow section-label">
          <span class="section-label__text">{{ $t('SectionFour.subtitle') }}</span>
        </p>
        <h2 id="sec4" class="ta-head__title">{{ $t('SectionFour.title') }}</h2>
      </header>

      <ul class="ta-grid">
        <li
          v-for="(item, index) in audiences"
          :key="item.key"
          class="ta-card"
          :class="`ta-card--${item.key}`"
          :style="{ '--ta-i': index }"
          @pointermove="onPointerMove"
        >
          <span class="ta-card__spot" aria-hidden="true"></span>
          <span class="ta-card__glow" aria-hidden="true"></span>
          <span class="ta-card__trace" aria-hidden="true"></span>
          <span class="ta-card__arc" aria-hidden="true"></span>
          <span class="ta-card__dots" aria-hidden="true"></span>
          <span class="ta-card__node" aria-hidden="true"></span>

          <div class="ta-card__media">
            <img
              class="ta-card__img ta-card__img--dark"
              :src="item.dark"
              alt=""
              width="640"
              height="640"
              loading="lazy"
              decoding="async"
            />
            <img
              class="ta-card__img ta-card__img--light"
              :src="item.light"
              alt=""
              width="640"
              height="640"
              loading="lazy"
              decoding="async"
            />
          </div>

          <span class="ta-card__baseline" aria-hidden="true">
            <span class="ta-card__energy"></span>
          </span>

          <h3 class="ta-card__title">{{ item.title }}</h3>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TargetAudience',
  data() {
    return {
      armed: false,
      revealed: false
    }
  },
  computed: {
    audiences() {
      return [
        { key: 'cpos', image: 'cpos' },
        { key: 'emsps', image: 'emsps' },
        { key: 'car_manufacturer', image: 'automotive' },
        { key: 'user', image: 'ev-drivers' },
        { key: 'authority', image: 'government-research' }
      ].map((item) => ({
        key: item.key,
        title: this.$t(`SectionFour.${item.key}`),
        dark: require(`@/assets/images/Newlandindpage/target-audience/${item.image}-dark.webp`),
        light: require(`@/assets/images/Newlandindpage/target-audience/${item.image}-light.webp`)
      }))
    }
  },
  mounted() {
    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reducedMotion || !('IntersectionObserver' in window)) {
      this.revealed = true
      return
    }

    // Hide the cards only once JS is running, so content never stays invisible without it.
    this.armed = true
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return
        this.revealed = true
        this.observer.disconnect()
      },
      { threshold: 0.2 }
    )
    this.observer.observe(this.$refs.root)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    onPointerMove(event) {
      if (event.pointerType !== 'mouse') return
      const card = event.currentTarget
      const rect = card.getBoundingClientRect()
      card.style.setProperty('--ta-mx', `${event.clientX - rect.left}px`)
      card.style.setProperty('--ta-my', `${event.clientY - rect.top}px`)
    }
  }
}
</script>
